module.exports = __webpack_public_path__ + "img/hamza2.262c3723.png";